import { omit } from 'lodash';

import {
  CHANGE_VERSION,
  START_DUE_DATE_RANGE,
  JOB_FIELDS,
  TEAM_FIELDS,
  TASK_FIELDS,
  JOB_TEMPLATE_FIELDS,
  ASSIGN_TO,
  RECORD_LINKAGE,
} from '../constants';

const assignmentFormatter = (valuesArray) => valuesArray.map((entityObject) => {
  let entityWithFormatting = entityObject;

  if (entityWithFormatting[TASK_FIELDS.TEAM] && !entityWithFormatting[TASK_FIELDS.TEAM][TEAM_FIELDS.ID]) {
    entityWithFormatting = omit(entityWithFormatting, [TASK_FIELDS.TEAM]);
  }

  if (!entityWithFormatting[TASK_FIELDS.ASSIGNED_USER_ID]) {
    entityWithFormatting = omit(entityWithFormatting, [TASK_FIELDS.ASSIGNED_USER_ID]);
  }

  return omit(entityWithFormatting, [
    ASSIGN_TO,
    TASK_FIELDS.ASSIGNED_USER_NAME,
  ]);
});

const formatter = [
  {
    valueName: TASK_FIELDS.NAME,
    requestName: TASK_FIELDS.NAME,
  },
  {
    valueName: TASK_FIELDS.STATUS,
    requestName: TASK_FIELDS.STATUS,
  },
  {
    valueName: TASK_FIELDS.PRIORITY,
    requestName: TASK_FIELDS.PRIORITY,
  },
  {
    valueName: TASK_FIELDS.START_DUE_DATE_RANGE,
    requestName: TASK_FIELDS.START_DATE,
  },
  {
    valueName: TASK_FIELDS.START_DUE_DATE_RANGE,
    requestName: TASK_FIELDS.DUE_DATE,
  },
  {
    valueName: TASK_FIELDS.DESCRIPTION,
    requestName: TASK_FIELDS.DESCRIPTION,
  },
  {
    valueName: TASK_FIELDS.ASSIGNED_USER_ID,
    requestName: TASK_FIELDS.ASSIGNED_USER_ID,
  },
  {
    valueName: TASK_FIELDS.ASSIGNED_USER_NAME,
    requestName: TASK_FIELDS.ASSIGNED_USER_NAME,
  },
  {
    valueName: TASK_FIELDS.TEAM,
    requestName: TASK_FIELDS.TEAM,
  },
  {
    valueName: CHANGE_VERSION,
    requestName: CHANGE_VERSION,
  },
  {
    valueName: TASK_FIELDS.RECORD_LINKAGE,
    requestName: TASK_FIELDS.RECORD_LINKAGE,
  },
];

export const getCreateEditTaskPayload = formValues => {
  let formattedPayload = formatter.reduce((acc, field) => {
    const { valueName, requestName } = field;

    if (formValues[valueName] && field.valueName === START_DUE_DATE_RANGE) {
      const dateValue = formValues[valueName][0][requestName];

      if (dateValue) {
        acc[requestName] = dateValue;
      }
    } else if (formValues[valueName]) {
      acc[requestName] = formValues[valueName];
    }

    return acc;
  }, {});

  if (!formattedPayload[TASK_FIELDS.TEAM][TEAM_FIELDS.ID]) {
    formattedPayload = omit(formattedPayload, [TASK_FIELDS.TEAM]);
  }

  return omit(formattedPayload, [TASK_FIELDS.ASSIGNED_USER_NAME]);
};

export const getCreateEditJobPayload = (formValues) => {
  const formValuesWithFormatting = {
    ...formValues,
    [JOB_FIELDS.START_DATE]: formValues[START_DUE_DATE_RANGE][0][JOB_FIELDS.START_DATE],
    [JOB_FIELDS.DUE_DATE]: formValues[START_DUE_DATE_RANGE][0][JOB_FIELDS.DUE_DATE],
    [JOB_FIELDS.ASSIGN_TASK]: assignmentFormatter(formValues[JOB_FIELDS.ASSIGN_TASK]),
  };

  return omit(formValuesWithFormatting, [JOB_FIELDS.START_DUE_DATE_RANGE]);
};

export const getCreateEditJobTemplatePayload = (formValues) => ({
  ...formValues,
  [JOB_TEMPLATE_FIELDS.TASK_TEMPLATES]: assignmentFormatter(formValues[JOB_TEMPLATE_FIELDS.TASK_TEMPLATES]),
});

export const getCreateEditTeamPayload = (formValues) => {
  const memberIds = formValues[TEAM_FIELDS.MEMBERS].map(user => user.id);
  const formValuesWithMemberIds = {
    ...formValues,
    [TEAM_FIELDS.MEMBERS]: memberIds,
  };

  return formValuesWithMemberIds;
};

export const removeEmptyLinkage = (formValues) => {
  let formattedPayload = formValues;

  if (formattedPayload[RECORD_LINKAGE] && !formattedPayload[RECORD_LINKAGE].length) {
    formattedPayload = omit(formattedPayload, [RECORD_LINKAGE]);
  }

  return formattedPayload;
};
